import { DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { SparklesIcon } from "lucide-react";

interface OpportunityHeaderProps {
  title: string;
  type: string;
}

export const OpportunityHeader = ({ title, type }: OpportunityHeaderProps) => {
  return (
    <DialogHeader>
      <DialogTitle className="text-2xl flex items-center gap-2">
        {title}
        {type === 'audition' && (
          <SparklesIcon className="w-6 h-6 text-purple-500" />
        )}
      </DialogTitle>
    </DialogHeader>
  );
};